(function() { window.GUID_4fcc71f7_3799_47f5_8900_fb586231af72 = { getGuid: function() { return "4fcc71f7-3799-47f5-8900-fb586231af72"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let EntityType;
        (function (EntityType) {
            EntityType[EntityType["Player"] = 0] = "Player";
            EntityType[EntityType["Team"] = 1] = "Team";
        })(EntityType = Enumeration.EntityType || (Enumeration.EntityType = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=EntityType.pre.js.map
